import React, { CSSProperties } from 'react';

const escapeRegExp = (value: string) => value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

export const DEFAULT_HIGHLIGHT_STYLE: CSSProperties = {
  backgroundColor: '#f7ff00',
  color: '#000',
  padding: '0 2px',
  borderRadius: 2,
};

export const highlightText = (
  text: string,
  query: string,
  highlightStyle: CSSProperties = DEFAULT_HIGHLIGHT_STYLE,
): React.ReactNode => {
  if (!query) {
    return text;
  }
  const escaped = escapeRegExp(query);
  if (!escaped) {
    return text;
  }
  const regex = new RegExp(`(${escaped})`, 'gi');
  const parts = text.split(regex);
  const lowerQuery = query.toLowerCase();
  return (
    <>
      {parts.map((part, index) =>
        part.toLowerCase() === lowerQuery ? (
          <mark key={`${index}-${part}`} style={highlightStyle}>
            {part}
          </mark>
        ) : (
          <React.Fragment key={`${index}-${part}`}>{part}</React.Fragment>
        ),
      )}
    </>
  );
};
